export enum StandingOrdersDetailActions {
  skip = 'skip',
  suspend = 'suspend',
  activate = 'activate',
  delete = 'delete'
}
